import apiHandler from "@/utils/handlers/ApiConnectionHandler";

/** API **/
export const SET_API_KEY = 'setApiKey';

/** Errors **/
export const REGISTER_FAILURE = 'registerFailure';
export const RESET_REGISTER_FAILURE = 'resetRegisterFailure';

/** Form **/
export const SET_FORM_DATA = 'setFormData';
export const CLEAR_FORM_DATA = 'clearFormData';

/** Loading spinner **/
export const SET_LOADING = 'setLoading';

export const mutations = {
  /** API **/
  setApiKey(state, data) {
    state.apiKey = data;
    state.registerError = false;
    state.registerErrorText = '';
  },

  /** Errors **/
  registerFailure(state, errorObj) {
    state.registerError = true;
    state.registerErrorText = apiHandler.getRegisterErrorText(errorObj);
  },
  resetRegisterFailure(state) {
    state.registerError = false;
    state.registerErrorText = '';
  },

  /** Form **/
  setFormData(state, {fieldName, data, groupIndex, groupName}) {
    // add group field
    if (groupName) {
      // if the key is not there yet, add it with an array value
      if (!state.formData[groupName]) {
        state.formData[groupName] = [];
      }
      let childData = state.formData[groupName].find((data) => data.id == groupIndex);
      if (!childData) {
        // define the child data
        state.formData[groupName].push({
          /** here the ID is the group index, so your item has and ID you can set it as group index as a prop **/
          id: groupIndex,
          [fieldName]: data
        });
      } else {
        // update key and value or assign key value pair
        childData[fieldName] = data;
      }
    } else {
      // add regular field
      state.formData[fieldName] = data;
    }
  },
  clearFormData(state) {
    state.formData = {};
  },

  /** Loading spinner **/
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
}
